module.exports = __webpack_public_path__ + "static/media/01A.8504a11a.png";